<template>
  <section class="footer">
    <BaseButton outline size="large" @click="close">
      {{ $t('buttons.CANCEL') }}
    </BaseButton>
    <BaseButton
      ref="submitUnsplashImage"
      :disabled="!hasSelectedImage"
      theme="blue"
      size="large"
      @click="submit"
    >
      {{ $t('image.SELECT_IMAGE') }}
    </BaseButton>
  </section>
</template>

<script>
import BaseButton from '../base/BaseButton.vue'
export default {
  components: {
    BaseButton,
  },
  props: {
    hasSelectedImage: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ['onClose', 'onSubmitImage'],
  methods: {
    close() {
      this.$emit('onClose')
    },
    submit() {
      this.$emit('onSubmitImage')
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  margin-top: $spacing-s;
  @include form-action-buttons-layout;
}
</style>
